import React from 'react'
import styled from 'styled-components';
import UserAvatar from '../../../globalComponents/UserAvatar';
import img from '../../../assets/patternbg.png'
import { BiMicrophone } from 'react-icons/bi';
import { GiDrop, GiHand, GiKickScooter, GiDoor, GiDoorHandle } from 'react-icons/gi';
import { motion } from 'framer-motion';
import Room from '../../../app/Room';

interface SpeakerProp{
    firstName: string;
    lastName: string;
    image: string
    isRaiseHand: boolean
    iAmModrator: boolean
    userId: string
}

export default function Speaker({firstName,image,lastName,isRaiseHand,iAmModrator,userId}:SpeakerProp) {
    return (
        <SpeakerStyle>
            <div className="top">
                <div className="pattern-bg" style={{zIndex:0}} ><img src={img} alt="" /></div>
                <div className="title-bold">{firstName} {lastName}</div>
            </div>
            <div className="image"><UserAvatar firstname={firstName} lastname={lastName} img={image} size={50} /></div>
            <div className="bottom" style={{zIndex:2}}>
                <div>
                    <BiMicrophone size={20} />
                </div>
                {isRaiseHand && (
              <div className="pointer">
                <motion.div
                  animate={{ rotate: 10 }}
                  transition={{
                    repeat: 7,
                    repeatType: "reverse",
                    duration: 1,
                  }}
                >
                  <GiHand color="#a59a00" size={20} />
                </motion.div>
              </div>
            )}
                {iAmModrator && (
              <div style={{zIndex:0}} onClick={()=>Room.adminRemoveUserAsSpeaker(userId)}>
                  <GiDoorHandle  size={20} />
              </div>
            )}

            </div>
        </SpeakerStyle>
    )
}

const SpeakerStyle = styled.div`
    position: relative;
    width: 200px;
    height: 130px;
    background: ${prop => prop.theme.foreground};
    margin-right: 10px;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: ${prop => prop.theme.subtleShadow};
    .bottom{
        display: flex;
        align-items: flex-end;
        height: 60%;
        padding: 15px;
        div {
            margin-right: 10px;
        }
    }
    .top{
        /* position: relative; */
        z-index: 0;
        width: 100%;
        height: 50%;
        background-color: ${prop => prop.theme.fadeBg};
        display: flex;
        color: ${prop => prop.theme.color};
        justify-content: flex-end;
        align-items: flex-end;
        flex-direction: column;
        padding: 0 10px;
        font-size: 13px;
        .pattern-bg{
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            opacity: 0.6;
            img{
                width: 100%;
                height: 100%;
                object-fit: cover;
                opacity: 0.1;
            }
        }
    }
    .image{
        position: absolute;
        top: 50%;
        left: 7px;
        transform: translateY(-50%);
    }
`;